import { combineReducers } from 'redux';
import firmOnbaordingReducer from '../v2/Onboarding/Reducers/firmOnboardingReducer';

import performanceReducer from '../v2/Performance/reducer/reducer';
import rewardsReducer from '../v2/Benefits/Rewards/Reducer/RewardsReducer';
import shopReducer from '../v3/Beneficiary/ShopInsurance/reducer/reducer';
import nomineeReducer from '../v2/Benefits/Beneficiary/reducer/nomineeReducer';
import beneficiaryReducer from '../v2/Benefits/Beneficiary/reducer/beneficiaryReducer';

import loginReducer from '../v3/Reducers/LoginReducer';
import distributorReducer from '../v3/Reducers/DistributerReducer';
import orderReducer from '../v3/Reducers/OrderReducer/orderReducer';
import dpReducer from '../v3/Reducers/DPReducer/dpReducer';
import dashboardReducer from '../v3/Common/Dashboard/dashboardReducer';
import authReducer from '../v3/Auth/Redux/authReducer';
import FirmOnboardingReducer from '../v3/FirmOnboarding/Redux/firmOnboardingReducer';
import bcmOrderReducer from '../v3/Reducers/BCM/BCMReducer';
import fmcgReducer from '../v3/Reducers/FMCG/fmcgReducer';
import entityReducer from '../v3/Reducers/Entity/EntityReducer';
import reportReducer from '../v3/Reducers/Reports/reducer';
import AddressReducer from '../v3/Reducers/Address/AddressReducer';

const appReducer = combineReducers({
  loginReducer,
  distributorReducer,
  orderReducer,
  fmcgReducer,
  beneficiaryReducer,
  nomineeReducer,
  bcmOrderReducer,
  reportReducer,
  performanceReducer,
  rewardsReducer,
  entityReducer,
  shopReducer,
  dpReducer,
  dashboardReducer,
  authReducer,
  FirmOnboardingReducer,
  AddressReducer
});
const initialState = appReducer({}, {});

const rootReducer = (state, action) => {
  if (action.type == 'LOGOUT') {
    localStorage.clear();
    return appReducer(initialState, action);
  } else {
    return appReducer(state, action);
  }
};

export default rootReducer;
